import LTR from "@brand-icons/global/replay/replay-ltr.svg";
import RTL from "@brand-icons/global/replay/replay-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ReplayIcon = iconFactory("ReplayIcon", LTR, RTL);
